export default {
    "profile": "Perfil",
    "logout": "Cerrar sesión",
    "dashboard": "Panel",
    "password": "Contraseña",
    "language": "Idioma",
    "paymentbr": "Pago",
    "subscriptionPaymentMethod": "Suscripción y método de pago",
    "nothingchanged": "Nada ha cambiado",
    "somethingWentWrong": "Algo salió mal ! Por favor intenta nuevamente más tarde",
    "pleaseTryAgainAfterSometime": "Por favor, inténtalo de nuevo después de un tiempo.",
    "noChanges": "Sin cambio",
    "invalidEmailFormat": "El formato del correo electrónico no es válido.",
    "chooseYourPreferredLanguage": "Por favor elija su idioma preferido.",
    "selectLanguage": "Seleccione el idioma",
    "update": "Actualizar",
    "languagePreferences": "Preferencias de idioma",
    "packageOf": "Paquete de",
    "satelliteReport": "informes satelitales",
    "pastureReport": "informes de pastos",
    "upTo": "Hasta",
    "animals": "animales",
    "back": "Atrás",
    "perMonth": "Por mes",
    "perYear": "Por año",
    "continue": "Continuar",
    "changePlan": "Cambio de plan",
    "addOn": "Añadir",
    "totalPrice": "Precio total",
    "availableAddOns": "Complementos disponibles",
    "next": "Próximo",
    "congratulations": "Felicidades",
    "done": "HECHO",
    "deforestationComplianceAssessment": "Evaluaciones de cumplimiento de deforestación",
    "warning": "Advertencia",
    "yourDataMightLost": "Es posible que se pierdan sus datos.",
    "clickOnSaveBtnMsg": "Haga clic en el botón Guardar para conservar sus datos.",
    "discardChanges": "Descartar los cambios",
    "action": "Comportamiento",
    "sendRequest": "Enviar petición",
    "success": "Éxito",
    "yourRequestSuccessfullySubmitted": "Su solicitud fue enviada exitosamente.",
    "informShortly": "Su solicitud ha sido enviada exitosamente. Su informe de análisis le será enviado en breve.",
    "search": "Buscar",
    "pending": "Pendiente",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "primaryGeofence": "Geocerca primaria",
    "Zero/Negligible Deforestation Probability": "Probabilidad de deforestación cero/negligible",
    "Low Deforestation Probability": "Baja probabilidad de deforestación",
    "High Deforestation Probability": "Alta probabilidad de deforestación",
    "login": {
        "welcome": "¡Bienvenido! Acceso",
        "welInfo": "Ingrese sus credenciales.",
        "login": "Acceso",
        "emailMobile": "Correo electrónico/Móvil",
        "forgotPassword": "Has olvidado tu contraseña",
        "register": "Registro",
        "unableToLogin": "Incapaz de iniciar sesión",
        "emailMobileCannotEmpty": "El correo electrónico/móvil no puede estar vacío.",
        "invalidEmailMobileFormat": "Formato de correo electrónico/móvil no válido.",
        "passwordCannotEmpty": "La contraseña no puede estar vacía.",
        "passwordLengthCanlessthan8": "La longitud de la contraseña no puede ser inferior a 8 caracteres.",
        "email": "Correo electrónico",
        "phone": "Teléfono",
        "or": "O",
        "alreadyHaveAccount": "Ya tienes una cuenta",
        "loginNow": "Inicia sesión ahora",
        "registerOption": "Elige una opción para registrarte",
        "signUpWith": "Registrarte con"
    },
    "user": {
        "profileUpdated": "El perfil se ha actualizado correctamente",
        "profileNotUpdated": "El perfil no se ha actualizado",
        "otpSentOnEmail": "¡La OTP se envió correctamente!",
        "otpSentSuccessFully": "Su código OTP fue enviado",
        "unableToVerifyEmail": "No se puede verificar el correo electrónico",
        "emailCanNotBeEmpty": "Los campos de correo electrónico no se pueden vaciar",
        "firstName": "Nombre de pila",
        "lastName": "Apellido",
        "email": "Correo electrónico",
        "mobile": "Móvil",
        "currentPassword": "Contraseña actual",
        "newPassword": "Nueva contraseña",
        "repeatNewPassword": "Repita la nueva contraseña",
        "firstNameRequired": "Se requiere el primer nombre.",
        "lastNameRequired": "El apellido es obligatorio",
        "emailRequired": "correo electronico es requerido",
        "onlyAlphabet": "Solo puede contener alfabetos",
        "notMoreThan15Char": "No puede tener más de 15 caracteres.",
        "phoneCannotLessThan8Char": "El teléfono no puede tener menos de 8 caracteres.",
        "countryCodeRequire": "Se requiere el código de país",
        "changePassword": "Cambiar la contraseña",
        "goodIdeaToUsePassword": "Es una buena idea utilizar una contraseña segura que no utilice en ningún otro lugar.",
        "enterCurrentPassword": "Introducir la contraseña actual",
        "enterNewPassword": "Ingrese nueva clave",
        "reEnterPassword": "Escriba la contraseña otra vez",
        "pleaseTypeOldPassword": "Por favor escriba la contraseña anterior.",
        "pleaseTypeNewPassword": "Por favor escriba una nueva contraseña.",
        "pleaseTypeConfirmPassword": "Por favor escriba confirmar contraseña.",
        "passwordChangedSuccesFully": "Contraseña cambiada con éxito",
        "passwordDoesNotMatch": "Las contraseñas no coinciden.",
        "passwordRequired": "se requiere contraseña",
        "emailOrPhoneIsRequired": "Se requiere correo electrónico o número de teléfono"
    },
    "subscription": {
        "subscription": "Suscripción",
        "membershipPlan": "Planes de membresía",
        "currentMembershipPlan": "Plan de membresía actual",
        "validUpTo": "Válida hasta",
        "viewAllAddOns": "VER TODOS LOS COMPLEMENTOS",
        "renewValidity": "Renovar Vigencia",
        "buyNow": "Comprar ahora",
        "upgradeMembershipPlan": "Actualizar plan de membresía",
        "chooseYourMembershipPlan": "Su plan de membresía elegido",
        "chooseOptionalAddOns": "Puedes elegir complementos opcionales",
        "yourSelectedAddons": "Sus complementos seleccionados",
        "addAnotherAddOn": "Agregar otro complemento",
        "paymentMethod": "Método de pago",
        "addingAPaymentMethod": "Agregar un método de pago",
        "paymentSuccessful": "¡Su pago fue exitoso!",
        "weHaveEmailed": "Hemos enviado una copia de su recibo por correo electrónico a example@email.com",
        "paymentAuthorizedSuccessfully": "Pago autorizado exitosamente.",
        "paymentSuccessfulPrompt": "Pago exitoso. Plan actualizado.",
        "paymentCancelled": "Pago cancelado. Inténtalo de nuevo."
    },
    "registerFarm": "Registrar Granja",
    "requestDeforestationReport": "Solicitar informe de deforestación",
    "paymentMenu": "Pago",
    "complianceCertificate": "Certificado de conformidad",
    "helpDisk": "Disco de ayuda",
    "faqs": "Preguntas frecuentes",
    "enquiries": "Consultas",
    "contactUs": "Contáctenos",
    "payment": {
        "basicPlan": "Plan Básico",
        "advancePlan": "Plan de avance",
        "usdPerMonthPlus": "USD por mes más",
        "perReport": "por informe",
        "deforestationAnalyticsCertificateDownload": "Descarga del certificado de análisis de deforestación"
    },
    "farm": {
        "farmOwnershipType": "Tipo de propiedad agrícola",
        "licenceNum": "Número de licencia",
        "viewFarm": "Ver Granja",
        "stateProvince": "Provincia/Estado",
        "postalNumberShouldSimilarToFarm": "El número postal de la finca es similar al número de la casa.",
        "videoTutorial": "Vídeotutorial",
        "clickOnMapMSG": "Haga clic en el mapa para comenzar a geocercar",
        "prev": "Anterior",
        "next": "Próximo",
        "dragVertexMsg": "También puedes arrastrar los vértices o eliminarlos usando el botón de eliminar en el lado derecho. La geovalla también se puede borrar usando el botón borrar",
        "farmAddedSuccessfully": "Granja agregada exitosamente",
        "perimeter": "Perímetro",
        "area": "Área",
        "clearGeofence": "Borrar geocerca",
        "deleteSelectedVertex": "Eliminar vértice seleccionado",
        "pleaseStartDrawing": "Comience a dibujar la geocerca en el mapa.",
        "chooseTheDate": "Elige la fecha",
        "updateGeofenceForThisFarm": "ACTUALIZAR GEOFENCE para esta finca",
        "farmUpdateSuccessfully": "Granja actualizada exitosamente",
        "farmZone": "Zonas agrícolas",
        "addNewZones": "Agregar nuevas zonas",
        "zoneName": "Nombre de zona",
        "addZoneToCreate": "Haga clic en Agregar zonas para crear una zona para esta granja.",
        "noZoneCreated": "Aún no se han creado zonas.",
        "searchAndAddPin": "Buscar y agregar un pin",
        "zoneNameWillBeHere": "El nombre de la zona estará aquí",
        "editZone": "Editar zona",
        "nameOfTheField": "Nombre del campo",
        "zoneDetails": "Detalles de zona",
        "addZone": "Agregar zona",
        "nameOfTheZone": "Nombre de la zona",
        "geofenceIsRequiredToAdd": "Se requiere geocerca para agregar zona. Haga clic en \"Editar granja\" para agregar detalles de Geocerca a su granja.",
        "thisFieldApplyHelpText": "Este campo solo se aplica a usted si pertenece a alguna cooperativa (una cooperativa es una asociación autónoma de personas unidas voluntariamente para satisfacer sus necesidades y aspiraciones económicas, sociales y culturales comunes a través de una empresa de propiedad conjunta y controlada democráticamente). SI pertenece a una cooperativa, por favor indique el identificador único de esa cooperativa, puede ser un número de registro o licencia que identifique de manera única a la cooperativa con la que se asocia.",
        "farmRegistrationID": "ID de registro de granja",
        "farmerName": "Nombre del granjero",
        "farmerRegistrationID": "Identificación de registro de agricultor",
        "dateOfRequest": "Fecha de solicitud",
        "status": "Estado",
        "address": "DIRECCIÓN",
        "save": "Ahorrar",
        "farmAddress": "Dirección de la ubicación de la granja",
        "corporateName": "Nombre corporativo",
        "corporateMailingAddress": "Dirección postal corporativa",
        "farmID": "ID de granja",
        "onTheFarm": "En la granja",
        "userRoles": "Roles del usuario",
        "adduser": "Agregar usuario",
        "addAuser": "Agregar un usuario",
        "uploadUsers": "Subir usuarios",
        "addNewUser": "Añadir nuevo usuario",
        "selectDept": "Seleccionar Departamento",
        "selectRole": "Seleccionar rol",
        "editUser": "editar usuario",
        "totalFarms": "Granjas totales",
        "NoAnimalsRegisteredForthisFarm": "No hay animales registrados para esta granja.",
        "farmsPerPage": "Granjas por página",
        "regularFarms": "Granjas regulares",
        "farmRegisteredProducts": "Productos agrícolas registrados",
        "searchByFarmNameAndId": "Buscar por nombre e ID de granja",
        "loadingProductsPleaseWait": "Cargando productos... Espere por favor",
        "farmName": "Nombre de la granja",
        "farmLocation": "Ubicación de la granja",
        "productName": "nombre del producto",
        "stockStatus": "Estado del inventario",
        "inStock": "En stock",
        "searchByProductName": "Buscar por nombre de producto",
        "productCategory": "categoria de producto",
        "products": "Productos",
        "yourLocationIsDisabled": "Tu ubicación está deshabilitada. Busque su ubicación en los menús de la izquierda.",
        "close": "Cerca",
        "farms": "Granjas",
        "zones": "Zonas",
        "registerAfarm": "Registrar una granja",
        "govtRegistry": "Gobierno. Registro",
        "cooperativeID": "Identificación de cooperativa/sindicato",
        "cooperativeName": "Nombre de la cooperativa/sindicato",
        "farmType": "Tipo de granja",
        "contractMating": "Apareamiento por contrato",
        "customization": "Personalización",
        "recordsPerpage": "Registros por página",
        "restoreDefault": "Restaurar valor predeterminado",
        "apply": "Aplicar",
        "CommunityName": "Nombre de la comunidad",
        "searchState": "Búsqueda por identificación de granja, registro gubernamental, identificación de cooperativa, tipo de granja, acoplamiento por contrato",
        "farmOwner": "Dueño de Granja",
        "govRegistrationNo": "Número de registro gubernamental",
        "farmInformation": "Información de la granja",
        "ownershipType": "Tipo de Propiedad",
        "farmLicenseInformation": "Información de licencia agrícola",
        "licenseNumber": "Número de licencia",
        "licenseExpiryDate": "Fecha de vencimiento de la licencia",
        "regulatorName": "Nombre del regulador",
        "regulatorRepresentativeName": "Nombre del representante del regulador",
        "farmLocationSize": "Ubicación y tamaño de la granja",
        "productionSystem": "Sistema agrícola",
        "country": "País",
        "state": "Estado",
        "city": "Pueblo/Pueblo/Ciudad",
        "farmNumber": "Número de granja",
        "postal": "Código postal",
        "houseNumber": "Número de casa",
        "farmRegistration": "Registro de granja",
        "cancel": "Cancelar",
        "register": "Registro",
        "ok": "OK",
        "totalFarmSize": "Tamaño total de la granja",
        "geographicLocation": "Ubicación geográfica",
        "farmGeographicLocation": "Ubicación geográfica de la granja",
        "perimeterPointLongitude": "Longitud del punto perimetral",
        "perimeterPointLatitude": "Latitud del punto perimetral",
        "perimeterPointLabel": "Etiqueta de punto perimetral",
        "perimeterLength": "Longitud del perímetro",
        "farmLatitude": "Latitud de la granja",
        "farmLongitude": "Longitud de la granja",
        "latitude": "Latitud",
        "longitude": "Longitud",
        "areaUnit": "Unidad de área",
        "walkAndMeasure": "CAMINAR Y MEDIR",
        "useGeofenceTool": "UTILIZAR LA HERRAMIENTA DE GEOCALLA",
        "editFarm": "Editar granja",
        "update": "Actualizar",
        "editAfarm": "Editar una granja",
        "nextFarm": "Próxima Granja",
        "nameoftheFarm": "Nombre de la Granja",
        "registerAProduct": " Registrar un producto",
        "farmProducts": "Productos agrícolas",
        "calf": "Becerro",
        "steer": "Dirigir",
        "heifer": "Novilla",
        "sire": "Padre",
        "dam": "Presa",
        "registerAnAnimal": "Registrar un animal",
        "farmAnimals": "Animales de granja",
        "farm_type": "tipo granja",
        "farm_Owner": "Dueño de Granja",
        "dateOfRegistration": "Fecha de registro",
        "dataIsNotAvailableForThisFarm": "Los datos no están disponibles para esta granja",
        "registerNewProduct": "Registre un nuevo producto",
        "information": "Información",
        "licenseInfo": "Información de licencia",
        "locationInfo": "Información de ubicación",
        "geoLocation": "Ubicación geográfica",
        "perimeterLengthState": "Longitud del perímetro de las fincas (longitud de la cerca)",
        "totalFarmSizeState": "Tamaño de una granja",
        "productionSystemState": "Sistema de Producción utilizado en la Granja",
        "contractMatingState": "Código de Programa de Apareamiento por Contrato en el que Participa la Granja.",
        "ownershipTypeState": "Tipo de propiedad",
        "regulatorRepresentativeNameState": "Nombre de la persona que representa al regulador que emitió la licencia",
        "regulatorNameState": "Nombre del regulador que emitió la licencia",
        "licenseExpiryDateState": "Fecha de vencimiento de la licencia actual",
        "licenseNumberState": "Número de licencia emitido por el regulador",
        "plotNumberState": "Número de casa de la finca.",
        "plotNumber": "Número de granja",
        "streetStatement": "Nombre de la calle de la finca.",
        "cityStatement": "Ciudad donde se encuentra ubicada la finca.",
        "stateStatement": "Región del país donde se encuentra ubicada la finca.",
        "countryState": "País donde se encuentra la finca.",
        "farmStateInfo": "Dirección de ubicación de la granja",
        "perimeterPointLongitudeState": "Longitud de un punto de la finca.",
        "perimeterPointLatitudeState": "Latitud de un punto de la finca.",
        "perimeterPointLabelState": "Etiqueta de Punto.",
        "farmLongitudeState": "Longitud de la finca.",
        "farmLatitudeState": "Latitud de la finca.",
        "deleteFarm": "Eliminar granja",
        "corporateRegistrationNum": "Número de registro corporativo",
        "farmLocationIsRequired": "Se requiere la ubicación de la granja."
    },
    "deforestation": {
        "addZoneToThisFarm": "Agregar zonas a esta granja",
        "eudrForestAssessment": "Evaluaciones forestales del EUDR",
        "requestEudrForestAssessment": "SOLICITAR EVALUACIÓN FORESTAL EUDR",
        "pleaseChooseOption": "Por favor elija la opción",
        "requestForestReport": "Solicitar Informe Forestal",
        "noDeforestationReportMsg": "No se han solicitado informes de deforestación. Solicite amablemente algunos informes de deforestación para incluirlos aquí.",
        "allCountries": "Todos los países",
        "allRegions": "Todas las regiones",
        "allFarms": "Todas las granjas",
        "allStatus": "Todo el estado",
        "viewCertificate": "Ver Certificado",
        "requestComplianceCertificate": "SOLICITAR CERTIFICADO DE CUMPLIMIENTO",
        "assessmentNo": "Evaluación no",
        "blockchainCertificationInfo": "El hash de validación del certificado Blockchain estará disponible tras la aceptación del certificado",
        "blockchainCertificationValidation": "Validación de certificado blockchain",
        "openBlockchainPage": "Abrir página de cadena de bloques",
        "clickOnAboveLink": "Haga clic en el enlace de arriba para validar el certificado en blockchain",
        "shareCertificate": "Compartir certificado",
        "high": "Alto",
        "low": "Bajo",
        "zeroOrNegigible": "Cero o insignificante",
        "deforestationProbability": "Probabilidad de deforestación",
        "colorCode": "Codigo de color",
        "geofenceAarea": "Área de geocerca",
        "percentageOfGeofenceArea": "Porcentaje del área de geocerca",
        "overallDeforestationProbability": "Probabilidad general de deforestación",
        "deforestationComplianceReport": "Informes de cumplimiento de deforestación",
        "noDeforestationComplianceReport": "No se encontró ningún informe electrónico que cumpla con las normas sobre deforestación",
        "loadingDeforestationComplianceReport": "Cargando el informe electrónico de cumplimiento de la deforestación",
        "farmRegistrationId": "ID de registro de granja",
        "farmerName": "Nombre del granjero",
        "farmerRegistrationId": "Identificación de registro de agricultor",
        "uniqueFarmerId": "Identificación única del granjero",
        "uniqueFarmId": "ID de granja única",
        "farmLocation": "Ubicación de la granja",
        "area": "Área",
        "farmAddress": "Dirección de la granja",
        "dateOfRequest": "Fecha de solicitud",
        "status": "Estado",
        "settings": "Ajustes",
        "assignmentIssued": "Asignación emitida",
        "certificateIssued": "Certificado emitido",
        "complianceCertification": "Certificación de cumplimiento",
        "noComplianceCertification": "No se encontró ninguna certificación de cumplimiento",
        "loadingComplianceCertification": "Certificación de cumplimiento de carga",
        "assessmentReport": "Informe de evaluación",
        "downloadPDF": "Descargar PDF",
        "print": "Imprimir",
        "back": "Atrás",
        "farmDetails": "Detalles de la granja",
        "dimitraFarmId": "Identificación de la granja Dimitra",
        "dimitraFermerId": "Identificación del granjero de Dimitra",
        "totalGeofenceAreaHA": "Área total de geocerca (HA)",
        "forestLossHA": "Pérdida de bosque (HA)",
        "forestGainHA": "Ganancia forestal (HA)",
        "forestUnchangedHA": "Bosque sin cambios (HA)",
        "forestUnchanged": "Bosque sin cambios",
        "forestLoss": "Pérdida de bosque",
        "forestGain": "Ganancia forestal",
        "totalGeofenceArea": "Área total de geocerca",
        "forestAssessmentHelp": "Si tiene preguntas sobre este informe o necesita ayuda para comprenderlo, contáctenos a través de la Mesa de Ayuda.",
        "allReport": "Todos los informes",
        "deforestationRepot": "Informes de deforestación",
        "requestDeforestationReportNow": "SOLICITE INFORME DE DEFORESTACIÓN AHORA",
        "noRecordFound": "ningún record fue encontrado",
        "noDeforestationReportRequested": "No se han solicitado informes de deforestación. Solicite amablemente algunos informes de deforestación para incluirlos aquí.",
        "deforestationImage": "Imagen de deforestación",
        "reqDeforestationReport": "Solicitar informe de deforestación",
        "confirm": "Confirmar",
        "newForestArea": "Nueva área forestal",
        "deforestedArea": "Área deforestada",
        "existingForestArea": "Área forestal existente",
        "deforestation": "Deforestación",
        "farmName": "Nombre de la granja",
        "location": "Ubicación",
        "dateOfInterest": "Fecha de interés",
        "geofenceArea": "Área de geocerca (HA)",
        "deforestationArea": "Área de Deforestación (HA)",
        "treeGainArea": "Área de ganancia de árbol (HA)",
        "currentForestArea": "Área forestal actual (HA)",
        "view": "Vista",
        "locationInfoRequired": "Se requiere información de ubicación",
        "geofenceNameRequired": "El nombre de la geocerca es obligatorio",
        "futureDateSelected": "Fecha futura seleccionada",
        "reportGeneratedSuccessfully": "Informe generado exitosamente",
        "reportCannotAdded": "No se puede agregar el informe.",
        "primaryFarmNotFound": "Granja primaria no encontrada.",
        "pleaseRegisterFarmFirst": "Por favor registre la granja primero"
    },
    "certificate": {
        "allCertificate": "Todos los certificados",
        "certificate": "Certificado"
    }
}